<script setup>
defineProps({
  color: {
    type: String,
    default: '',
  },
  left: {
    type: Boolean,
    default: false,
  },
  right: {
    type: Boolean,
    default: false,
  },
  size: {
    type: String,
    default: '',
  },
  customClass: {
    type: String,
  },
});
</script>

<template>
  <q-icon
    :color="color"
    :left="left"
    :right="right"
    :size="size"
    :class="customClass"
  >
    <slot />
  </q-icon>
</template>
<style scoped>
.proxify-error-500 {
  color: #f04438;
}
.proxify-error-600 {
  color: #d92d20;
}
.proxify-success-500 {
  color: #12b76a;
}
.proxify-success-600 {
  color: #039855;
}
</style>
